(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["admin/main/includes/modals/_promo_modal.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = {"informational": "message-information","warning": "message-warning","error": "message-error","success": "badge-correct","device-rotate": "device-rotate"};
frame.set("svgs", t_1, true);
if(frame.topLevel) {
context.setVariable("svgs", t_1);
}
if(frame.topLevel) {
context.addExport("svgs", t_1);
}
output += "\n\n";
if(!runtime.contextOrFrameLookup(context, frame, "type")) {
output += "\n    ";
var t_2;
t_2 = "informational";
frame.set("type", t_2, true);
if(frame.topLevel) {
context.setVariable("type", t_2);
}
if(frame.topLevel) {
context.addExport("type", t_2);
}
output += "\n";
;
}
output += "\n\n";
var t_3;
t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "svgs")),runtime.contextOrFrameLookup(context, frame, "type"));
frame.set("svg_path", t_3, true);
if(frame.topLevel) {
context.setVariable("svg_path", t_3);
}
if(frame.topLevel) {
context.addExport("svg_path", t_3);
}
output += "\n\n<div class=\"comet-modal-overlay js-comet-modal-overlay comet-modal-overlay--backdrop\" role=\"dialog\"></div>\n<div class=\"comet-modal js-comet-modal\" role=\"document\" tabindex=\"0\">\n    <div id=modal-default class=\"comet-modal__inner\">\n        <div class=\"comet-modal__header comet-long-form-text\">\n            <h3 class=\"comet-modal__header-content\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modalHeader"), env.opts.autoescape);
output += "</h3>\n        </div>\n        <div class=\"comet-modal__content comet-long-form-text\">\n            <div ";
if(runtime.contextOrFrameLookup(context, frame, "block_msg_id")) {
output += " id=\"";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "block_msg_id")?runtime.contextOrFrameLookup(context, frame, "block_msg_id"):""), env.opts.autoescape);
output += "\"";
;
}
output += " class=\"comet-block-message comet-block-message--";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "type"), env.opts.autoescape);
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "block_msg_class")?" " + runtime.contextOrFrameLookup(context, frame, "block_msg_class"):""), env.opts.autoescape);
output += "\">\n                <div class=\"comet-block-message__icon-box\">\n                    <svg class=\"comet-block-message__icon\" aria-hidden=\"true\" focusable=\"false\">\n                        <use xlink:href=\"";
output += runtime.suppressValue((lineno = 24, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["comet/2.x/comet.svg#" + runtime.contextOrFrameLookup(context, frame, "svg_path")])), env.opts.autoescape);
output += "\"></use>\n                    </svg>\n                </div>\n                <div class=\"comet-block-message__content comet-long-form-text\">\n                    <p>";
if(runtime.contextOrFrameLookup(context, frame, "modalText")) {
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modalText"), env.opts.autoescape);
;
}
output += "</p>\n                </div>\n            </div>\n        </div>\n        <div class=\"comet-modal__footer\">\n            <div class=\"comet-modal__button-row\">\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showCancelButton")) {
output += "\n                    <button class=\"comet-button comet-button--ghost comet-modal__button comet-modal__button--cancel js-comet-modal__close-button\">Cancel</button>\n                ";
;
}
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showBackToHome")) {
output += "\n                    <a class=\"comet-button comet-button--primary comet-modal__button comet-modal__button--confirm\" href=\"/promos\">Back To Highlights</a>\n                ";
;
}
output += "\n                ";
if(runtime.contextOrFrameLookup(context, frame, "showOKButton")) {
output += "\n                    <button class=\"comet-button comet-button--primary comet-modal__button comet-modal__button--confirm\">OK</button>\n                ";
;
}
output += "\n                \n            </div>\n        </div>\n    </div>\n</div>\n\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/admin/templates/includes/modals/_promo_modal", function(){});

